import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import useFetch from "../fetch";
import fetchResidentMedications from "./fetchResidentMedications";

export default function useMedicationsLoader() {
  const medications = useSelector((state) => state.medications);
  const organization = useSelector((state) => state.organization);
  const resident = useSelector((state) => state.resident);
  const dispatch = useDispatch();
  const fetch = useFetch();
  const loadingRef = useRef(false);

  useEffect(() => {
    if (medications.length > 0 || loadingRef.current || !resident?.id) return;

    loadingRef.current = true;
    fetchResidentMedications(fetch, organization.name, resident.id)
      .then((data) => {
        dispatch({
          type: "UPDATE_MEDICATIONS",
          payload: { medications: data },
        });
      })
      .always(() => {
        loadingRef.current = false;
      });
  }, [medications.length, organization.name, resident.id]);
}
